// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mfa-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.mfa-modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mfa-modal-container {
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  padding-bottom: 5px;
}

.mfa-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
}
.mfa-modal-header label {
  color: #1a1a1a;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  text-align: center;
}
.mfa-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
}
.mfa-modal-header .close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}
.mfa-modal-header .close-button:hover {
  color: #333;
}

.mfa-modal-head {
  padding: 5px;
  text-align: center;
  margin: 20px 0;
  padding: 5px 23px 0 23px;
}
.mfa-modal-head label {
  font-size: 16px;
  line-height: 1.5;
  color: #002f6c;
  margin-bottom: 20px;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.mfa-modal-footer {
  padding: 10px;
  text-align: center;
}
.mfa-modal-footer .mfa-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.mfa-modal-footer .mfa-actions button {
  flex: 1;
  padding: 5px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.mfa-modal-footer .mfa-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.mfa-modal-footer .mfa-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.mfa-modal-footer .mfa-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.mfa-modal-footer .mfa-actions button.verify-button:hover {
  background-color: #002f6c;
}
.mfa-modal-footer .mfa-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

.mfa-modal-body {
  padding: 0px;
  text-align: center;
}
.mfa-modal-body .qr-code-container {
  display: flex;
  justify-content: center;
}
.mfa-modal-body .qr-code-container .qr-code-image {
  max-width: 200px;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.mfa-modal-body .mfa-instructions {
  text-align: center;
  margin-bottom: 20px;
  color: #555;
  font-size: 0.95rem;
}
.mfa-modal-body .mfa-code-inputs {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.mfa-modal-body .mfa-code-inputs input {
  width: 40px;
  height: 48px;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.mfa-modal-body .mfa-code-inputs input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
.mfa-modal-body .error-message {
  color: #e53935;
  text-align: center;
  margin-bottom: 16px;
  font-size: 0.875rem;
}
.mfa-modal-body .mfa-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.mfa-modal-body .mfa-actions button {
  flex: 1;
  padding: 12px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.mfa-modal-body .mfa-actions button.cancel-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.mfa-modal-body .mfa-actions button.cancel-button:hover {
  background-color: #e5e5e5;
}
.mfa-modal-body .mfa-actions button.verify-button {
  background-color: #002f6c;
  color: white;
  border: none;
}
.mfa-modal-body .mfa-actions button.verify-button:hover {
  background-color: #002f6c;
}
.mfa-modal-body .mfa-actions button.verify-button:disabled {
  background-color: #4e769b;
  cursor: not-allowed;
}

/* Contenedor principal del modal */
.modal-container {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  font-family: "Arial", sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

h2 {
  color: #002f6c;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

p {
  color: #1a1a1a;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.qr-code {
  margin: 0 auto 1.5rem;
  width: 150px;
  height: 150px;
}

.label {
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 0.8rem;
}

.otp-fields {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 1.8rem;
  flex-wrap: wrap;
}

.otp-input {
  width: 38px;
  height: 38px;
  font-size: 18px;
  text-align: center;
  border: 2px solid #002f6c;
  border-radius: 6px;
}

.actions {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn-cancel,
.btn-verify {
  flex: 1 1 45%;
  padding: 10px 0;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
}

.btn-cancel {
  background: #e0e0e0;
  color: #333;
}

.btn-verify {
  background: #002f6c;
  color: white;
}

/* 📱 Responsivo para móviles */
@media (max-width: 480px) {
  .otp-input {
    width: 36px;
    height: 48px;
    font-size: 20px;
  }
  .modal-container {
    padding: 1.5rem 1rem;
  }
  .btn-cancel, .btn-verify {
    flex: 1 1 100%;
  }
  .qr-code {
    width: 120px;
    height: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/mfa/mfa-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,yCAAA;AAEJ;AAAI;EACE,UAAA;EACA,mBAAA;AAEN;;AAEE;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AACJ;AACI;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AACN;AAEI;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AAAN;AAGI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AADN;AAGM;EACE,WAAA;AADR;;AAME;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,wBAAA;AAHJ;AAKI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAHN;;AAQE;EACE,aAAA;EACA,kBAAA;AALJ;AAMI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAJN;AAMM;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAJR;AAMQ;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AAJV;AAMU;EACE,yBAAA;AAJZ;AAQQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AANV;AAQU;EACE,yBAAA;AANZ;AASU;EACE,yBAAA;EACA,mBAAA;AAPZ;;AAaE;EACE,YAAA;EACA,kBAAA;AAVJ;AAYI;EACE,aAAA;EACA,uBAAA;AAVN;AAaM;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAXR;AAeI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAbN;AAgBI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAdN;AAgBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAdR;AAgBQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAdV;AAmBI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAlBN;AAoBM;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAlBR;AAoBQ;EACE,yBAAA;EACA,WAAA;EACA,sBAAA;AAlBV;AAoBU;EACE,yBAAA;AAlBZ;AAsBQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AApBV;AAsBU;EACE,yBAAA;AApBZ;AAuBU;EACE,yBAAA;EACA,mBAAA;AArBZ;;AA4BE,mCAAA;AACF;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,yCAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;AAzBF;;AA4BA;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAzBF;;AA4BA;;EAEE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,mBAAA;EACA,WAAA;AAzBF;;AA4BA;EACE,mBAAA;EACA,YAAA;AAzBF;;AA4BA,+BAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAzBF;EA4BA;IACE,oBAAA;EA1BF;EA6BA;IACE,cAAA;EA3BF;EA8BA;IACE,YAAA;IACA,aAAA;EA5BF;AACF","sourcesContent":[".mfa-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1100;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s, visibility 0.3s;\n  \n    &.active {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n  \n  .mfa-modal-container {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    padding-bottom: 5px;\n  }\n  \n  .mfa-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    border-bottom: 1px solid #eee;\n    text-align: center;\n\n    label {\n      color: #1a1a1a;\n      font-size: 0.95rem;\n      margin-bottom: 1.5rem;\n      text-align: center;\n    }\n  \n    h2 {\n      margin: 0;\n      font-size: 1.25rem;\n      color: #333;\n    }\n  \n    .close-button {\n      background: none;\n      border: none;\n      font-size: 1.5rem;\n      cursor: pointer;\n      color: #666;\n  \n      &:hover {\n        color: #333;\n      }\n    }\n  }\n  \n  .mfa-modal-head {\n    padding: 5px;\n    text-align: center;\n    margin: 20px 0; \n    padding: 5px 23px 0 23px;\n\n    label {\n      font-size: 16px;\n      line-height: 1.5;\n      color: #002f6c;\n      margin-bottom: 20px;\n      max-width: 360px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    \n  }\n\n  .mfa-modal-footer {\n    padding: 10px;\n    text-align: center;\n    .mfa-actions {\n      display: flex;\n      justify-content: space-between;\n      gap: 16px;\n  \n      button {\n        flex: 1;\n        padding: 5px;\n        border-radius: 4px;\n        font-size: 1rem;\n        cursor: pointer;\n        transition: background-color 0.2s;\n  \n        &.cancel-button {\n          background-color: #f5f5f5;\n          color: #333;\n          border: 1px solid #ddd;\n  \n          &:hover {\n            background-color: #e5e5e5;\n          }\n        }\n  \n        &.verify-button {\n          background-color: #002f6c;\n          color: white;\n          border: none;\n  \n          &:hover {\n            background-color: #002f6c;\n          }\n  \n          &:disabled {\n            background-color: #4e769b;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n  .mfa-modal-body {\n    padding: 0px;\n    text-align: center;\n  \n    .qr-code-container {\n      display: flex;\n      justify-content: center;\n      \n  \n      .qr-code-image {\n        max-width: 200px;\n        height: auto;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n      }\n    }\n  \n    .mfa-instructions {\n      text-align: center;\n      margin-bottom: 20px;\n      color: #555;\n      font-size: 0.95rem;\n    }\n  \n    .mfa-code-inputs {\n      display: flex;\n      justify-content: center;\n      gap: 8px; \n  \n      input {\n        width: 40px;\n        height: 48px;\n        text-align: center;\n        font-size: 1.25rem;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n  \n        &:focus {\n          outline: none;\n          border-color: #4a90e2;\n          box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n        }\n      }\n    }\n  \n    .error-message {\n      color: #e53935;\n      text-align: center;\n      margin-bottom: 16px;\n      font-size: 0.875rem;\n    }\n  \n    .mfa-actions {\n      display: flex;\n      justify-content: space-between;\n      gap: 16px;\n  \n      button {\n        flex: 1;\n        padding: 12px;\n        border-radius: 4px;\n        font-size: 1rem;\n        cursor: pointer;\n        transition: background-color 0.2s;\n  \n        &.cancel-button {\n          background-color: #f5f5f5;\n          color: #333;\n          border: 1px solid #ddd;\n  \n          &:hover {\n            background-color: #e5e5e5;\n          }\n        }\n  \n        &.verify-button {\n          background-color: #002f6c;\n          color: white;\n          border: none;\n  \n          &:hover {\n            background-color: #002f6c;\n          }\n  \n          &:disabled {\n            background-color: #4e769b;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n\n  /* Contenedor principal del modal */\n.modal-container {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\nh2 {\n  color: #002f6c;\n  font-weight: 700;\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\np {\n  color: #1a1a1a;\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.qr-code {\n  margin: 0 auto 1.5rem;\n  width: 150px;\n  height: 150px;\n}\n\n.label {\n  font-weight: bold;\n  font-size: 0.95rem;\n  margin-bottom: 0.8rem;\n}\n\n.otp-fields {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 1.8rem;\n  flex-wrap: wrap;\n}\n\n.otp-input {\n  width: 38px;\n  height: 38px;\n  font-size: 18px;\n  text-align: center;\n  border: 2px solid #002f6c; \n  border-radius: 6px;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.btn-cancel,\n.btn-verify {\n  flex: 1 1 45%;\n  padding: 10px 0;\n  border: none;\n  border-radius: 6px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.btn-cancel {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.btn-verify {\n  background: #002f6c;\n  color: white;\n}\n\n/* 📱 Responsivo para móviles */\n@media (max-width: 480px) {\n  .otp-input {\n    width: 36px;\n    height: 48px;\n    font-size: 20px;\n  }\n\n  .modal-container {\n    padding: 1.5rem 1rem;\n  }\n\n  .btn-cancel, .btn-verify {\n    flex: 1 1 100%;\n  }\n\n  .qr-code {\n    width: 120px;\n    height: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
